import { create } from "zustand"

type EditSectionDialogState = {
  isOpen: boolean
}

type EditSectionDialogActions = {
  onOpen: () => void
  onClose: () => void
}

const useEditSectionDialogV1 = create<
  EditSectionDialogState & EditSectionDialogActions
>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}))

export default useEditSectionDialogV1
